import { render, staticRenderFns } from "./mbk-locked-deposites.vue?vue&type=template&id=039ad334&scoped=true"
import script from "./mbk-locked-deposites.vue?vue&type=script&lang=js"
export * from "./mbk-locked-deposites.vue?vue&type=script&lang=js"
import style0 from "./mbk-locked-deposites.vue?vue&type=style&index=0&id=039ad334&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039ad334",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/mbk/mbk-locked-deposites.vue
// module id = kYpi
// module chunks = 0